import { InscalarProvider as Provider } from '@ilg-core/inscalar-web/react'
import { PropsWithChildren } from 'react'

import type { InscalarConfig, LogAdapter } from '@ilg-core/inscalar-web'

export const getIsDebugMode = () => {
    if (typeof window === 'undefined') {
        return false
    }
    return window.location.search.indexOf('debug') > -1
}

const logAdapter: LogAdapter = {
    debug: (message: string) => {
        console.debug(message)
    },
    info: (message: string) => {
        console.info(message)
    },
    warn: (message: string) => {
        console.warn(message)
    },
    error: (message: string) => {
        console.error(message)
    },
}

const inscalarConfig: InscalarConfig = {
    projectId: process.env.NEXT_PUBLIC_INSCALAR_PROJECT_ID ?? '',
    apiKey: process.env.NEXT_PUBLIC_INSCALAR_API_KEY ?? '',
    environment:
        process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 'prod' : 'test',
    apiBaseUrl: process.env.NEXT_PUBLIC_INSCALAR_API_BASE_URL ?? '',
    logAdapter,
    debug: getIsDebugMode(),
}

export function InscalarProvider({ children }: PropsWithChildren) {
    return <Provider config={inscalarConfig}>{children}</Provider>
}
